// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8Rtv2","label":"styles_label__3QccT"};